import _ from 'underscore';
import $ from 'jquery';
import { DeterministicWrapperView } from '@bingads-webui/deterministic-wrapper-view';
import {
  TargetingType,
  SettingsView,
  TargetingSettingsContext,
} from '@bingads-webui-campaign/targeting-settings-scaffolds';

export class EditAdGroupSettingsView extends SettingsView {
  initialize({
    campaignId,
    adgroupId,
    perfMarker,
    deps,
  }) {
    super.initialize({
      campaignId,
      adgroupId,
      setting: TargetingType.AllSettings,
    });

    const campaign = TargetingSettingsContext.pageContext.CurrentCampaign;
    const campaignType = _.result(campaign, 'CampaignType');

    const EditAdGroupPage = TargetingSettingsContext.editAdGroupPage;
    const EditAdGroupPageWrapper = class extends DeterministicWrapperView {
      viewFactory() {
        let settingsPage;

        if (campaignType === 8) {
          const reachControlOptions = deps.isNewUI ? {
            modifyTarget: () => _.delay(() => {
              $('.audience-reach-estimate-container').css('top', `${$('.app-content-container-col').scrollTop()}px`);
            }, 500),
            threshold: [0.25, 0.5, 0.75, 1.0],
            rootMargin: '100px 0px 0px 250px',
          } : {};

          settingsPage = new TargetingSettingsContext.AudienceAdgroupSettingsWizard({
            viewContext: {
              accountCurrencyCode: TargetingSettingsContext.pageContext.AccountCurrencyCode,
              currentCampaign: TargetingSettingsContext.pageContext.CurrentCampaign,
              currentAdGroup: TargetingSettingsContext.pageContext.CurrentAdGroup,
            },
            perfMarker: perfMarker.createChild('AdGroupScope_AllSettings_EditAudienceAdGroup'),
            deps,
            reachControlOptions,
          });
        } else {
          settingsPage = new EditAdGroupPage({
            deps,
            perfMarker,
          });
        }

        return settingsPage;
      }
    };

    this.setChild('settings-container', new EditAdGroupPageWrapper());
  }

  /**
   * Class name of the root element
   * @type {string}
   * @override
   */
  get className() { return 'edit-adgroup-settings-view'; }
}
